<script>
import { environment } from "@app/store/envStore.svelte.js";
/* Firebase */
import { auth } from '@app/configs/firebase.js';
import { signOut } from 'firebase/auth';
import * as m from '@app/paraglide/messages.js';
import MenuItem from "../../menu/MenuItem.svelte";
import { replace } from 'svelte-spa-router';
async function logout() {
    try {
        if (environment.online){
            await signOut(auth);
        } else {
            //Clear Local Storage key for `cc-offline-license`
            localStorage.removeItem('cc-offline-license');
            localStorage.removeItem('cc-license-key');
        }        
    } catch (error) {
        console.log(error);
    } finally {        
        // Navigate to /login
        replace("/login");
    }   
}
</script>
<MenuItem
    label={m.logout()}
    icon="bi-box-arrow-right"
    id="logoutMenuItem"
    onSelect={logout} />